// extracted by mini-css-extract-plugin
export default {"header":"MainHeader_header__k08jf"};